// extracted by mini-css-extract-plugin
export var label = "_en-2";
export var slideContainer = "_en-0";
export var slider = "_en-1";